(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-savings"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-savings')) {
    customElements.define('bundle-savings', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        if (!this.form) return;
        this.variants = JSON.parse(this.querySelector('[data-bundle-variants]').textContent);
        this.controller = new AbortController();
        this.scope = this.form;
        this.money = new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency});
        this.scope.addEventListener('change', event => {
          if (this.contains(event.target) && event.target.matches('input[type="radio"]')) {
            const input = this.form.querySelector('[name="quantity"]');
            if (input) {
              input.value = event.target.value;
              const selector = input.closest('quantity-selector-component');
              if (selector && typeof selector.onQuantityChange === 'function') {
                selector.onQuantityChange();
                selector.updateButtonStates();
              }
              input.dispatchEvent(new Event('input',{bubbles:true}));
              input.dispatchEvent(new Event('change',{bubbles:true}));
            }
          }
          queueMicrotask(() => this.refresh());
        },{signal:this.controller.signal});
        this.scope.addEventListener('click',event => {
          if (!this.contains(event.target)) queueMicrotask(() => this.refresh());
        },{signal:this.controller.signal});
        this.refresh();
      }
      disconnectedCallback() { this.controller?.abort(); }
      refresh() {
        const id = this.form.querySelector('[name="id"]')?.value;
        const variant = this.variants.find(v => v.id === id);
        if (!variant) return;
        const quantity = Number(this.form.querySelector('[name="quantity"]')?.value || 1);
        for (const row of this.querySelectorAll('.bundle-savings__option')) {
          const radio = row.querySelector('input');
          const count = Number(radio.value);
          const total = (variant.price - (count > 1 ? Math.floor(variant.price / 10) : 0)) * count;
          const original = Math.max(variant.compare,variant.price) * count;
          row.querySelector('[data-bundle-total]').textContent = this.money.format(total / 100);
          const previous = row.querySelector('[data-bundle-original]');
          previous.textContent = this.money.format(original / 100);
          previous.hidden = original <= total;
          radio.checked = quantity === count;
          radio.disabled = !variant.available || count < variant.min || (count - variant.min) % variant.step !== 0 || (variant.max > 0 && count > variant.max) || (variant.stock !== null && count > variant.stock);
        }
        const customTotal = this.form.querySelector('.ds-add-price');
        if (customTotal) customTotal.textContent = this.money.format((variant.price - (quantity > 1 ? Math.floor(variant.price / 10) : 0)) * quantity / 100);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
